import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource, MatTree } from '@angular/material/tree';
import { TreeNode } from '../TreeNode';
import { DOData, TabVM } from '../../DOData';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'cylib-mat-tree-nested',
  templateUrl: './mat-tree-nested.component.html',
  styleUrls: ['./mat-tree-nested.component.css']
})

export class MatTreeNestedComponent implements OnInit {

    @Input() public dataIn: TreeNode[];
    @Input() public loaderKey: string;

    public readArr: ReadonlyArray<TreeNode>;

    ButonIconMinus = faMinus;
    ButonIconPlus = faPlus;

    public set listVM(DOData: TabVM) {
        this._listVM = DOData;
    }
    public get listVM(): TabVM {
        return this._listVM;
    }
    private _listVM: TabVM = new TabVM();
    public listDocdata: Array<Array<DOData>>;

    public selectedNode: TreeNode;
    public selectedNodeId: number = 0;
    public selectedLevel: string = "";
    public selectedConfigTierId: number = 0;
    public selectedMatrixTierId: number = 0;

    public activeNode: TreeNode;

    recursive: boolean = false;
    levels = new Map<TreeNode, number>();
    treeControl = new NestedTreeControl<TreeNode>(node => node.children);

    dataSource = new MatTreeNestedDataSource<TreeNode>();

    @Output() mat_tree_nestedAfterViewInit: EventEmitter<MatTreeNestedComponent> =
        new EventEmitter<MatTreeNestedComponent>();

    @Output() mat_tree_nested_SelecteNode: EventEmitter<TreeNode> = new EventEmitter<TreeNode>();

    @ViewChild('treeSelector') tree: MatTree<any>;

    constructor(private _changeDetectorRef: ChangeDetectorRef) { }

    ngOnInit() {
        this.dataSource.data = this.dataIn;
    }

    ngAfterViewInit() {
        this.mat_tree_nestedAfterViewInit.emit(this);
    }

    hasChildren = (_: number, node: TreeNode) => !!node.children && node.children.length > 0;

    public expandAll() {
        //this.treeControl.dataNodes = this.dataIn;
        this.treeControl.expandAll();
    }

    public collapseAll() {
        this.treeControl.collapseAll();
    }

    public selectNode(node) {
        //alert(node.hdrId);
        this.selectedNode = node;
        this.selectedNodeId = node.hdrId;
        this.selectedLevel = node.level;
        this.selectedConfigTierId = node.configTierID;
        this.selectedMatrixTierId = node.matrixTierID;
        this.mat_tree_nested_SelecteNode.emit(this.selectedNode);
    }

    public refreshTree(_data: TreeNode[]) {
        const data = _data;
        this.dataSource.data = null;
        this.dataSource.data = data;
        //this.readArr = this.dataSource.data;
        //this.tree.renderNodeChanges(this.readArr);
        //this.expandAll();
    }

    //public addNode(node: TreeNode) {
    //    node.matrixTierID = this.findNodeMaxId(this.dataSource.data) + 1;
    //    this.dataSource.data.push(node);
    //    this.refreshTreeNode();
    //}

    //addChildNode(childrenNodeData: TreeNode) {
    //    childrenNodeData.matrixTierID = this.findNodeMaxId(this.dataSource.data) + 1;
    //    childrenNodeData.children.push(childrenNodeData);
    //    this.refreshTreeNode();
    //}

    //editNode(nodeToBeEdited: TreeNode) {

    //    //let index = this.findPosition(editId, this.dataSource.data);
    //    //let nodeToBeEdited: TreeNode = this.dataSource.data[0].children[0];

    //    //const fatherElement: TreeNode = this.findFatherNode(nodeToBeEdited.matrixTierID, this.dataSource.data);
    //    //let elementPosition: number = 0;
    //    //nodeToBeEdited.matrixTierID = this.findNodeMaxId(this.dataSource.data) + 1;
    //    //if (fatherElement[0]) {
    //    //    fatherElement[0].children[fatherElement[1]] = nodeToBeEdited;
    //    //} else {
    //    //    elementPosition = this.findPosition(nodeToBeEdited.matrixTierID, this.dataSource.data);
    //    //    this.dataSource.data[elementPosition] = nodeToBeEdited;
    //    //}

    //    // TEST

    //    //fatherElement.children[elementPosition] = nodeToBeEdited;

    //    this.refreshTreeNode();
    //}



    //deleteNode(nodeToBeDeleted: TreeNode) {
    //    const deletedElement: TreeNode = this.findFatherNode(nodeToBeDeleted.matrixTierID, this.dataSource.data);
    //    let elementPosition: number;
    //    //if (window.confirm('Are you sure you want to delete this node ?')) {
    //        if (deletedElement[0]) {
    //            deletedElement[0].Children.splice(deletedElement[1], 1);
    //        } else {
    //            elementPosition = this.findPosition(nodeToBeDeleted.matrixTierID, this.dataSource.data);
    //            this.dataSource.data.splice(elementPosition, 1);
    //        }
    //        this.refreshTreeNode();
    //    //}
    //}

    //findNodeMaxId(node: TreeNode[]) {
    //    const flatArray = this.flatJsonArray([], node);
    //    const flatArrayWithoutChildren = [];
    //    flatArray.forEach(element => {
    //        flatArrayWithoutChildren.push(element.matrixTierID);
    //    });
    //    return Math.max(...flatArrayWithoutChildren);
    //}

    //findPosition(id: number, data: TreeNode[]) {
    //    for (let i = 0; i < data.length; i += 1) {
    //        if (id === data[i].matrixTierID) {
    //            return i;
    //        }
    //    }
    //}

    //findFatherNode(id: number, data: TreeNode[]) {
    //    for (let i = 0; i < data.length; i += 1) {
    //        const currentFather = data[i];
    //        for (let z = 0; z < currentFather.children.length; z += 1) {
    //            if (id === currentFather.children[z]['matrixTierID']) {
    //                return [currentFather, z];
    //            }
    //        }
    //        for (let z = 0; z < currentFather.children.length; z += 1) {
    //            if (id !== currentFather.children[z]['matrixTierID']) {
    //                const result = this.findFatherNode(id, currentFather.children);
    //                if (result !== false) {
    //                    return result;
    //                }
    //            }
    //        }
    //    }
    //    return false;
    //}

    //flatJsonArray(flattenedAray: Array<TreeNode>, node: TreeNode[]) {
    //    const array: Array<TreeNode> = flattenedAray;
    //    node.forEach(element => {
    //        if (element.children) {
    //            array.push(element);
    //            this.flatJsonArray(array, element.children);
    //        }
    //    });
    //    return array;
    //}

}

